import React, { useState, useEffect } from 'react';
import { Row, Col, Input, Tag, Checkbox, Button, Card } from 'antd';
import { remove } from 'lodash'
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { API } from 'aws-amplify';
import FiltersTable from '../../FiltersTable/index.jsx';
import {usePagination} from '../../../../hooks/useFiltersPagination.js';


const { Search } = Input;

const UserConsumption = (
  {
    dataConsumed,
    setDataConsumed,
    additionalTelco,
    setAdditionalTelco,
    additionalNoTelco,
    setAdditionalNoTelco
  }
) => {
  const [selectedData1, setSelectedData1] = useState();
  const [selectedData2, setSelectedData2] = useState();
  const [selectedData3, setSelectedData3] = useState();
  const [searchValue1, setSearchValue1] = useState();
  const [searchValue2, setSearchValue2] = useState();
  const [searchValue3, setSearchValue3] = useState();
  const [showLoadingData1, setShowLoadingData1] = useState(false);
  const [showLoadingData2, setShowLoadingData2] = useState(false);
  const [showLoadingData3, setShowLoadingData3] = useState(false);
  const [selectedsData1, setSelectedsData1] = useState([]);
  const [selectedsData2, setSelectedsData2] = useState([]);
  const [selectedsData3, setSelectedsData3] = useState([]);
  const [banderaTags1, setBanderaTags1] = useState(false)
  const [banderaTags2, setBanderaTags2] = useState(false)
  const [banderaTags3, setBanderaTags3] = useState(false)

  const fetchFilter1 = async (filter = null) => {
    try {
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { query: "getConsumption", name_filter: "${filter}" }) {
            key
            description_filter
            type_filter
            value_filter
            id_statement
          }
        }`
      });
  
      const data = response.data.getFiltersRedshift.sort((a, b) => a.value_filter.localeCompare(b.value_filter));
  
      if (data[0].id_statement !== null) {
        await getValues({
          idStatement: data[0].id_statement,
          query: "getConsumption",
          setter: setSelectedData1,
          showLoading: setShowLoadingData1
        });
      } else {
        const newData = data.map(item => {
          const { id_statement, ...rest } = item;
          return rest;
        });
  
        setSelectedData1(newData.length > 0 && newData[0].value_filter !== "Sin Datos" ? newData : []);
        setShowLoadingData1(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    setShowLoadingData1(true);
    fetchFilter1(searchValue1);
  }, [searchValue1]);
  

  const fetchFilter2 = async (filter = null) => {
    try {
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { query: "getAdditionalTelcoCat", name_filter: "${filter}", is_like: false, like_position: 3, limit: 1000 }) {
            key
            description_filter
            type_filter
            value_filter
            id_statement
          }
        }`
      });
  
      const data = response.data.getFiltersRedshift.sort((a, b) => a.value_filter.localeCompare(b.value_filter));;
  
      if (data[0].id_statement !== null) {
        await getValues({
          idStatement: data[0].id_statement,
          query: "getAdditionalTelcoCat",
          setter: setSelectedData2,
          showLoading: setShowLoadingData2
        });
      } else {
        const newData = data.map(item => {
          const { id_statement, ...rest } = item;
          return rest;
        });
  
        setSelectedData2(newData.length > 0 && newData[0].value_filter !== "Sin Datos" ? newData : []);
        setShowLoadingData2(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    setShowLoadingData2(true);
    fetchFilter2(searchValue2);
  }, [searchValue2]);

  const fetchFilter3 = async (filter = null) => {
    try {
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { query: "getAdditionalNonTelcoCat", name_filter: "${filter}", is_like: false, like_position: 3, limit: 1000 }) {
            key
            description_filter
            type_filter
            value_filter
            id_statement
          }
        }`
      });
  
      const data = response.data.getFiltersRedshift.sort((a, b) => a.value_filter.localeCompare(b.value_filter));
  
      if (data[0].id_statement !== null) {
        await getValues({
          idStatement: data[0].id_statement,
          query: "getAdditionalNonTelcoCat",
          setter: setSelectedData3,
          showLoading: setShowLoadingData3
        });
      } else {
        const newData = data.map(item => {
          const { id_statement, ...rest } = item;
          return rest;
        });
  
        setSelectedData3(newData.length > 0 && newData[0].value_filter !== "Sin Datos" ? newData : []);
        setShowLoadingData3(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    setShowLoadingData3(true);
    fetchFilter3(searchValue3);
  }, [searchValue3]);

  useEffect(() => {
    setSelectedsData3(additionalNoTelco);
  }, [additionalNoTelco]);

  const getValues = async ({ idStatement, query, setter, showLoading }) => {
    let response = [];
    while (response.length === 0) {
      const result = await API.graphql({
        query: `query MyQuery {
          getData(input: {id_statement: "${idStatement}", query: "${query}" }) {
            key
            description_filter
            type_filter
            value_filter
          }
        }`
      });
      response = result.data.getData;

      if (response.length === 0) {
        await new Promise(resolve => setTimeout(resolve, 5000));
      }
    }
    setter(response.length > 0 && response[0].value_filter !== "Sin Datos" ? response : [])
    showLoading(false)
  };

  useEffect(() => {
    if (dataConsumed.length === 0) {
      setSelectedsData1([]);
      setBanderaTags1(false);
    }
  }, [dataConsumed]);
  
  useEffect(() => {
    if (additionalTelco.length === 0) {
      setSelectedsData2([]);
      setBanderaTags2(false);
    }
  }, [additionalTelco]);
  
  useEffect(() => {
    if (additionalNoTelco.length === 0) {
      setSelectedsData3([]);
      setBanderaTags3(false);
    }
  }, [additionalNoTelco]);

  const filters = [
    {
      title: "Consumo de datos (MB)",
      selectedData: selectedData1,
      setSelectedData: setSelectedData1,
      selectedsData: selectedsData1,
      setSelectedsData: setSelectedsData1,
      filterComponent: dataConsumed,
      setFilterComponent: setDataConsumed,
      banderaTags: banderaTags1,
      setBanderaTags: setBanderaTags1,
      showLoadingData: showLoadingData1, 
      setShowLoadingData: setShowLoadingData1, 
    },
    {
      title: "Gastos Adicionales (Telco)",
      selectedData: selectedData2,
      setSelectedData: setSelectedData2,
      selectedsData: selectedsData2,
      setSelectedsData: setSelectedsData2,
      filterComponent: additionalTelco,
      setFilterComponent: setAdditionalTelco,
      banderaTags: banderaTags2,
      setBanderaTags: setBanderaTags2,
      showLoadingData: showLoadingData2, 
      setShowLoadingData: setShowLoadingData2, 
    },
    {
      title: "Gastos Adicionales (No Telco)",
      selectedData: selectedData3,
      setSelectedData: setSelectedData3,
      selectedsData: selectedsData3,
      setSelectedsData: setSelectedsData3,
      filterComponent: additionalNoTelco,
      setFilterComponent: setAdditionalNoTelco,
      banderaTags: banderaTags3,
      setBanderaTags: setBanderaTags3,
      showLoadingData: showLoadingData3, 
      setShowLoadingData: setShowLoadingData3, 
    }
  ];

  const {
    currentPage,
    handleNext,
    handlePrev,
    visibleItems: visibleFilters,
    endIndex,
  } = usePagination(filters);

  return (
    <Row className="DemograficosColumns" gutter={16}>
      <Col span={12}>
        <Row gutter={[16, 24]}>
          {visibleFilters.map((filter, index) => (
            <Col span={12} key={index}>
              <h3>{filter.title}</h3>
              <FiltersTable
                selectedData={filter.selectedData}
                setSelectedData={filter.setSelectedData}
                selectedsData={filter.selectedsData}
                setSelectedsData={filter.setSelectedsData}
                filterComponent={filter.filterComponent}
                setFilterComponent={filter.setFilterComponent}
                banderaTags={filter.banderaTags}
                setBanderaTags={filter.setBanderaTags}
                showLoadingData={filter.showLoadingData}
                setShowLoadingData={filter.setShowLoadingData}
              />
            </Col>
          ))}
        </Row>
        {filters.length > 2 && (
          <Row style={{ marginTop: '20px', justifyContent: 'center' }}>
            <div style={{ display: 'flex', gap: '16px' }}>
              <Button
                className="navigation-button"
                shape="circle"
                icon={<LeftOutlined />}
                onClick={handlePrev}
                disabled={currentPage === 0}
              />
              <Button
                className="navigation-button"
                shape="circle"
                icon={<RightOutlined />}
                onClick={handleNext}
                disabled={endIndex >= filters.length}
              />
            </div>
          </Row>
        )}
      </Col>
      <Col span={12} >
        <Row gutter={[16, 16]} style={{ justifyContent: 'flex-end' }}> 
          <Card
              style={{
                width: 500,
                height: 300,
                marginTop: 20,
                overflow: 'auto',
                borderRadius: 15, 
              }}
            >
            {selectedsData1 && selectedsData1.map(({ key, value_filter }) => (
              <Tag
                key={key}
                className="TagsSelectFilters"
                closable
                onClose={e => {
                  const updatedSelecteds = selectedsData1.filter(item => item.key !== key);
                  setSelectedsData1(updatedSelecteds);
                  setDataConsumed(updatedSelecteds); 
                  setBanderaTags1(true);
                }}
              >
                {value_filter}
              </Tag>
            ))}
            {selectedsData2 && selectedsData2.map(({ key, value_filter }) => (
              <Tag
                key={key}
                className="TagsSelectFilters"
                closable
                onClose={e => {
                  const updatedSelecteds = selectedsData2.filter(item => item.key !== key);
                  setSelectedsData2(updatedSelecteds);
                  setAdditionalTelco(updatedSelecteds); 
                  setBanderaTags2(true);
                }}
              >
                {value_filter}
              </Tag>
            ))}
            {selectedsData3 && selectedsData3.map(({ key, value_filter }) => (
              <Tag
                key={key}
                className="TagsSelectFilters"
                closable
                onClose={e => {
                  const updatedSelecteds = selectedsData3.filter(item => item.key !== key);
                  setSelectedsData3(updatedSelecteds);
                  setAdditionalNoTelco(updatedSelecteds); 
                  setBanderaTags3(true);
                }}
              >
                {value_filter}
              </Tag>
            ))}
          </Card>
        </Row>
      </Col>
    </Row>
  );
}

export default UserConsumption;